import React, { useContext } from 'react';
import styled from 'styled-components';
import logo from 'images/logo_data_center.png';
import { I18nContext } from 'i18n';
import { Link as A } from 'raviger';
import { Container, Row, Col } from 'react-bootstrap'
import { getCurrentUser } from 'utils/getCurrentUser'
import { PrivateNavigation } from 'components'

const Header = () => {
  const { translate } = useContext(I18nContext);

  return (
    <StyledHeader>
      <HeaderContent className="py-3 mx-5">
        <Row>
          <Col className="d-inline-flex" md={4}>
            <A href="/">
              <StyledImage src={logo} className="pr-3"/>
            </A>
            <div className="my-auto ml-3">
              <Title>{translate('app_title')}</Title>
            </div>
          </Col>
          {
            getCurrentUser() &&
              <Col>
                <PrivateNavigation className="float-right" />
              </Col>
          }
        </Row>
      </HeaderContent>
    </StyledHeader>
  );
};

const StyledHeader = styled.header`
  border-top: ${(props) => `5px solid  ${props.theme.header.borderColor}`};
  border-bottom: ${(props) => `5px solid  ${props.theme.palette.primary[0]}`};
`;

const HeaderContent = styled.div`
  background-color: ${(props) => props.theme.header.backgroundColor};
  > .row {
    height: 6rem;
  }
`

const StyledImage = styled.img`
  width: 100px;
  border-right: ${(props) => `1px solid ${props.theme.header.color}`};
  margin-top: 1rem;
`;

const Title = styled.div`
  font-weight: 600;
  color: ${(props) => props.theme.palette.primary[0]};
  font-size: 1rem;
`;

export default Header;
